import { colorConstants } from 'theme/default'

export const LEFT = 'left'
export const CENTER = 'center'
export const RIGHT = 'right'
export const BOLD = 'bold'
export const ITALIC = 'italic'
export const UNDERLINED = 'underlined'
export const BULLETED_LIST = 'bulleted-list'
export const NUMBERED_LIST = 'numbered-list'
export const LIST_ITEM = 'list-item'
export const LINK = 'link'
export const PARAGRAPH = 'paragraph'
export const PARAGRAPH_CENTER = `${PARAGRAPH}-${CENTER}`
export const PARAGRAPH_RIGHT = `${PARAGRAPH}-${RIGHT}`
export const HIGHLIGHT = 'highlight'
export const BLOCK = 'block'
export const MARK = 'mark'
export const INLINE = 'inline'
export const SPAN = 'span'
export const SEPERATOR = 'seperator'
export const BORDER_NONE = 'border-none'
export const BORDER_LEFT = 'border-left'
export const BORDER_RIGHT = 'border-right'
export const BORDER_BOTH = 'border-both'
export const HIGHLIGHT_COLOR = colorConstants.lightBlue
export const DEFAULT_NODE = PARAGRAPH

export const COMPACT_MODE = 'compact'
export const COMPLETE_MODE = 'complete'
